<!-- Breadcrumb padronizado -->
<app-breadcrumb containerStyle="normal"></app-breadcrumb>

<div class="card" style="border-radius: 10px">
  <div class="card-body">
    <div class="row text-left">
      <div class="col-sm-12">
        <div class="d-flex justify-content-between mb-0">
          <h1 class="text-bold-400" style="color: #4e7977">
            Licenças e Permissões
          </h1>
        </div>
      </div>
      <div class="col-sm-12">
        <p class="mb-2 mt-2" style="font-size: 20px">
          Visualize e gerencie o acesso dos clientes aos módulos do sistema. Utilize a busca e os filtros para encontrar e atualizar informações de forma eficiente.
        </p>
      </div>
    </div>
  
    <form #servForm="ngForm" novalidate>
      <div class="form-row">
        <div class="col">
          <div class="form-group">
            <div class="controls">
              <label for="nome">CLIENTE</label>
              <fieldset class="form-group position-relative has-icon-right">
                <input
                  type="text"
                  id="nome"
                  class="form-control"
                  [(ngModel)]="nomeCliente"
                  name="nome"
                  placeholder="Procure por nome"
                  required
                  aria-invalid="false"
                />
                <div class="form-control-position">
                  <i class="fa fa-search"></i>
                </div>
              </fieldset>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="form-group">
            <div class="controls">
              <label>ACESSO AO MÓDULO</label>
              <div class="d-flex align-items-center mt-2">
                <label class="ml-2" style="font-size: 16px; text-transform: math-auto; font-weight: 400">
                  <input type="checkbox" [checked]="allSelected" (change)="toggleAll($event)" class="mr-1"> Todos
                </label>
                <label class="ml-3" style="font-size: 16px; text-transform: math-auto; font-weight: 400">
                  <input type="checkbox" [(ngModel)]="options.simulador" (change)="updateAllSelected()" class="mr-1"> Simulador
                </label>
                <label class="ml-3" style="font-size: 16px; text-transform: math-auto; font-weight: 400">
                  <input type="checkbox" [(ngModel)]="options.sapiem" (change)="updateAllSelected()" class="mr-1"> Sapiem
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    <div class="form-row d-flex justify-content-end align-items-center">
      <div class="col-auto">
        <button
          type="button"
          class="btn btn-outline-primary"
          (click)="clearFilters()"
        >
          Limpar filtros
        </button>
      </div>
      <div class="col-auto">
        <button
          type="button"
          class="btn btn-outline-primary mb-2 mb-md-0"
          (click)="applyFilters()"
        >
          Pesquisar <i class="fa fa-search mr-1"></i>
        </button>
      </div>
    </div>
  </div>
</div>

<div class="card" style="border-radius: 10px">
  <table class="table text-center table-striped" style="padding: 10px">
    <thead>
      <tr>
        <th (click)="sortTable('municipio')" class="cursor-pointer">
          <div class="d-flex align-items-center justify-content-center">
            Município
            <div class="sort-icons ml-1">
              <i *ngIf="sortColumn !== 'municipio'" class="fa fa-caret-up"></i>
              <i *ngIf="sortColumn !== 'municipio'" class="fa fa-caret-down"></i>
              <i
                *ngIf="sortColumn === 'municipio'"
                class="fa"
                [ngClass]="{
                  'fa-caret-up': sortDirection === 'asc',
                  'fa-caret-down': sortDirection === 'desc'
                }"
              ></i>
            </div>
          </div>
        </th>
        <th (click)="sortTable('simulador')" class="cursor-pointer">
          <div class="d-flex align-items-center justify-content-center">
            Simulador
            <div class="sort-icons ml-1">
              <i *ngIf="sortColumn !== 'simulador'" class="fa fa-caret-up"></i>
              <i *ngIf="sortColumn !== 'simulador'" class="fa fa-caret-down"></i>
              <i
                *ngIf="sortColumn === 'simulador'"
                class="fa"
                [ngClass]="{
                  'fa-caret-up': sortDirection === 'asc',
                  'fa-caret-down': sortDirection === 'desc'
                }"
              ></i>
            </div>
          </div>
        </th>
        <th (click)="sortTable('sapiem')" class="cursor-pointer">
          <div class="d-flex align-items-center justify-content-center">
            Sapiem
            <div class="sort-icons ml-1">
              <i *ngIf="sortColumn !== 'sapiem'" class="fa fa-caret-up"></i>
              <i *ngIf="sortColumn !== 'sapiem'" class="fa fa-caret-down"></i>
              <i
                *ngIf="sortColumn === 'sapiem'"
                class="fa"
                [ngClass]="{
                  'fa-caret-up': sortDirection === 'asc',
                  'fa-caret-down': sortDirection === 'desc'
                }"
              ></i>
            </div>
          </div>
        </th>
        <th>Ações</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let cidade of cidadesFiltered | slice : (page - 1) * pageSize : (page - 1) * pageSize + pageSize">
        <td>{{ cidade.municipio }}</td>
        <td>
          <span class="badge" [ngClass]="cidade.simulador ? 'badge-status-ativo' : 'badge-status-inativo'">
            {{ cidade.simulador ? 'Ativo' : 'Inativo' }}
          </span>
        </td>
        <td>
          <span class="badge" [ngClass]="cidade.sapiem ? 'badge-status-ativo' : 'badge-status-inativo'">
            {{ cidade.sapiem ? 'Ativo' : 'Inativo' }}
          </span>
        </td>
        <td>
          <button type="button" class="btn btn-outline-primary" (click)="gotoDetails(cidade)">
            <i class="fa fa-eye"></i> Detalhes
          </button>
        </td>
      </tr>
    </tbody>
  </table>

  <div class="form-row" *ngIf="cidadesFiltered.length > 0" style="padding: 0px 20px">
    <div class="d-flex justify-content-between align-items-center w-100">
      <div>
         Exibindo {{(page-1) * pageSize + 1}} a {{Math.min(page * pageSize, cidadesFiltered.length)}} de {{cidadesFiltered.length}} itens
      </div>
      <div class="d-flex justify-content-center">
        <ngb-pagination
        class="ml-auto pagination-square"
        style="margin-top: 10px; margin-right: 10px"
        *ngIf="cidadesFiltered.length > 0"
        [(page)]="page"
        [pageSize]="pageSize"
        [maxSize]="3"
        [rotate]="true"
        [boundaryLinks]="true"
        size="sm"
        [collectionSize]="cidadesFiltered.length"
      ></ngb-pagination>
      </div>
    </div>
  </div>
</div>
<ngx-spinner></ngx-spinner>
  